import { useCallback, useState } from 'react';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';

import Image from '../../components/image/Image';
import 'react-medium-image-zoom/dist/styles.css';
import { cn } from '../../tailwind';

export const ProductImage = ({
  imageUrl,
  allowZoom = true,
  className,
  size,
}: {
  imageUrl?: string | null;
  allowZoom?: boolean;
  className?: string;
  size?: 'small' | 'medium' | 'large';
}) => {
  const [isZoomed, setIsZoomed] = useState(false);

  const handleZoomChange = useCallback((shouldZoom: boolean) => {
    setIsZoomed(shouldZoom);
  }, []);

  if (!allowZoom) {
    return <FormattedImage imageUrl={imageUrl} size={size} />;
  }

  return (
    <div onClick={(e) => e.stopPropagation()} className="cursor-zoom-in">
      <ControlledZoom isZoomed={isZoomed} onZoomChange={handleZoomChange}>
        <FormattedImage imageUrl={imageUrl} className={className} size={size} />
      </ControlledZoom>
    </div>
  );
};

const FormattedImage = ({
  imageUrl,
  className,
  size,
}: {
  imageUrl?: string | null;
  className?: string;
  size?: 'small' | 'medium' | 'large';
}) => {
  return (
    <Image
      alt="product image"
      src={imageUrl}
      size={size}
      className={cn(
        'cursor-inherit min-w-16 h-10 w-16 rounded-md overflow-hidden object-contain',
        className,
      )}
    />
  );
};
